import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../../config/apiConfig';
import TravelHolidaysHero from '../../components/TravelHolidays/TravelHolidaysHero';
import UnforgettableTrip from '../../components/TravelHolidays/UnforgettableTrip';
import CustomizedHolidays from '../../components/TravelHolidays/CustomizedHolidays';
import TravelYourWay from '../../components/TravelHolidays/TravelYourWay';
import TravelFAQ from '../../components/TravelHolidays/TravelFAQ';
import OurAdditionalServices from '../../components/Emigrants/OurAdditionalServices';
import LatestArticles from '../../components/TravelHolidays/LatestArticles';
import ContactSection from '../../components/ContactSection'; // Reusing the global contact block for completeness

const TravelHolidays: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_CONFIG.BASE_URL}/travel-holidays-page`, {
          headers: API_CONFIG.HEADERS
        });
        if (response.data && (response.data.status === 'success' || response.data.data)) {
          setData(response.data.data || response.data);
        } else {
          setError("Failed to load travel holidays content.");
        }
      } catch (err) {
        console.error("Error fetching Travel Holidays page data:", err);
        setError("An error occurred while fetching page content.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <div className="min-h-[70vh] flex flex-col items-center justify-center bg-white font-manrope">
        <div className="w-12 h-12 border-4 border-[#c1272d] border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-[#0a1e3f] font-semibold text-lg animate-pulse">Loading amazing journeys...</p>
      </div>
    );
  }

  // Prepared structure for OurAdditionalServices (it maps cards inside data, API uses items)
  const additionalServicesData = data?.additional_services_section ? {
    title: data.additional_services_section.title,
    description: data.additional_services_section.description,
    cards: data.additional_services_section.items || []
  } : null;

  return (
    <main className="min-h-screen bg-white">
      {/* Hero Section for Travel and Holidays Page */}
      <TravelHolidaysHero data={data?.hero_section} />

      {/* Customized Holiday Packages and Air Ticketing */}
      <CustomizedHolidays data={data?.holiday_packages_section} />

      {/* Unforgettable Trip & Core Services + Carousel */}
      <UnforgettableTrip 
        unforgettableData={data?.unforgettable_trip_section} 
        carouselData={data?.carousel_section}
      />

      {/* Travel Your Way Section */}
      <TravelYourWay data={data?.travel_way_section} />

      {/* Additional Services */}
      <OurAdditionalServices data={additionalServicesData} />

      {/* Latest Articles Section */}
      <LatestArticles data={data?.blogs_section} />

      {/* Frequently Asked Questions */}
      <TravelFAQ data={data?.faq_section} />

      {/* Global Contact Footer Form */}
      <ContactSection />
    </main>
  );
};

export default TravelHolidays;


